const LS_KEY = 'wetags.recentlyAccessedNamespaces';
const MAX_NAMESPACES = 5;

export function setRecentlyAccessedNamespace(namespaceId: string) {
  const existing = localStorage.getItem(LS_KEY);
  let namespaces: string[] = existing ? JSON.parse(existing) : [];
  namespaces = namespaces.filter((ns) => ns !== namespaceId);
  namespaces.unshift(namespaceId);
  if (namespaces.length > MAX_NAMESPACES) {
    namespaces = namespaces.slice(0, MAX_NAMESPACES);
  }
  localStorage.setItem(LS_KEY, JSON.stringify(namespaces));
}

export function getRecentlyAccessedNamespaces() {
  const existing = localStorage.getItem(LS_KEY);
  let namespaces: string[] = existing ? JSON.parse(existing) : [];
  return namespaces;
}
